<template>
  <v-layout row wrap>
    <v-flex xs12>
      <child-toolbar :title="title" :buttons="buttons" />
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <template v-if="loaded">
            <v-flex xs12 lg6 v-for="employee in employees" :key="employee.id">
              <employee-card :value="employee" @delete="_delete" @edit="edit"
                             @expense="toExpenses" :editable="editable" />
            </v-flex>
          </template>
          <h2 v-else>Loading...</h2>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import Vuex from 'vuex'
import _ from 'lodash'

import EmployeeCard from './EmployeeCard'
import ChildToolbar from '@/components/ChildToolbar'

const btRequestEmployeesStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Employees')
const btRequestExpensesStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Expenses')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'BusinessTripRequestEmployees',
  components: {ChildToolbar, EmployeeCard},
  component: {
    EmployeeCard,
    ChildToolbar
  },
  props: {
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    employeeDetailRoute: {
      type: [String, Object],
      required: true
    },
    employeeNewRoute: {
      type: [String, Object],
      required: true
    },
    employeeDetailBackRoute: {
      type: [String, Object],
      required: true
    },
    expenseListRoute: {
      type: [String, Object],
      required: true
    },
    expenseListBackRoute: {
      type: [String, Object],
      required: true
    },
    expenseDetailRoute: {
      type: [String, Object],
      required: true
    },
    expenseNewRoute: {
      type: [String, Object],
      required: true
    }
  },
  data () {
    return {
      employees: [],
      loaded: false,
      title: 'Employees',
      buttons: [
        { tooltip: 'Add new employee',
          icon: 'add',
          to: {
            name: this.employeeNewRoute,
            params: {
              id: this.$route.params.id,
              backRoute: {
                name: this.$route.name,
                params: {
                  id: this.$route.params.id,
                  editable: this.editable,
                  employeeDetailRoute: this.employeeDetailRoute,
                  employeeNewRoute: this.employeeNewRoute,
                  employeeDetailBackRoute: this.employeeDetailBackRoute,
                  expenseListRoute: this.expenseListRoute,
                  expenseListBackRoute: this.expenseListBackRoute,
                  expenseDetailRoute: this.expenseDetailRoute,
                  expenseNewRoute: this.expenseNewRoute
                }
              }
            }
          },
          render: this.editable
        },
        {
          tooltip: 'Refresh',
          icon: 'refresh',
          handler: this.refresh
        }
      ]
    }
  },
  methods: {
    ...btRequestEmployeesStore.mapActions({
      getEmployees: 'getEmployees',
      deleteEmployee: 'deleteEmployee'
    }),
    ...btRequestExpensesStore.mapActions({
      getExpenses: 'getExpenses'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    loadResources () {
      const self = this

      self.loaded = false
      self.getEmployees({vueinstance: self, id: self.$route.params.id})
        .then(res => {
          self.employees = _.cloneDeep(res)
          self.employees.forEach(x => {
            // load expenses
            self.getExpenses({vueinstance: self, id: self.$route.params.id, empid: x.id})
              .then(res => {
                self.$set(x, 'expenses', res)
              })
              .catch(err => {
                self.$error(err)
              })
          })
          self.loaded = true
        })
        .catch(err => self.$error(err))
    },
    refresh () {
      this.loadResources()
    },
    _delete (employee) {
      const self = this
      function yesHandler () {
        self.deleteEmployee({vueinstance: self, id: self.$route.params.id, empid: employee.id})
          .then(res => {
            self.$error('Business Trip Request Employee ' + employee.employee.name + ' was deleted')
            self.closeConfirmation()
            self.refresh()
          })
      }

      function noHandler () {
        self.closeConfirmation()
      }

      this.showConfirmation({message: 'Are you sure?',
        title: 'Delete Business Trip Request Employee ' + employee.employee.name,
        buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]})
    },
    edit (employee) {
      this.$router.replace({name: this.employeeDetailRoute,
        params: {
          id: this.$route.params.id,
          empid: employee.id,
          editable: this.editable,
          backRoute: this.employeeDetailBackRoute
        }})
    },
    toExpenses (employee) {
      this.$router.replace({name: this.expenseListRoute,
        params: {id: this.$route.params.id,
          empid: employee.id,
          editable: this.editable,
          expenseDetailRoute: this.expenseDetailRoute,
          backRoute: this.expenseListBackRoute,
          expenseNewRoute: this.expenseNewRoute
        }})
    }
  },
  mounted () {
    this.loadResources()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.loadResources())
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestEmployees.vue